import Image from "next/image";

export default function token() {
  return (
    <section className="  mx-auto px-6 lg:px-20 py-20">
      <div className="  flex justify-center py-8">
      <iframe  className=" w-full aspect-video" src="/NiftySky_Deck.mp4"></iframe>
      </div>
      <div className="flex justify-center ">
        <Image
          src="/images/space-token.png"
          alt="Picture of the author"
          width={1500}
          height={860}
        />
      </div>
    </section>
  );
}
